// extracted by mini-css-extract-plugin
export default {"root":"ToolbarControl_root__Mqtyf","label":"ToolbarControl_label__oXJS1","contents":"ToolbarControl_contents__H6pUT"};